<template>
  <v-tab-item>
    <v-card>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab>Timeline Item</v-tab>
          <v-tab :disabled="!popup">Popup Content</v-tab>
          <v-tab :disabled="!popup">Actions/Links</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card style="min-height:425px">
              <v-card-text>
                <p>This is the text that will appear in the card on the timeline. This should be a short description of the item.</p>
                <v-row>
                  <v-col>
                    <v-text-field v-model="title" label="Title/Name" outlined></v-text-field>
                    <v-textarea v-model="subtitle" label="Sub-text" rows="2" outlined hide-details></v-textarea>
                  </v-col>
                  <v-col>
                    <v-timeline dense>
                      <v-timeline-item :color="getButtonColor(item)" :icon="getButtonIcon(item)">
                        <v-card>
                          <v-toolbar dense>
                            <h4 style="font-style:italic">Timeline Item Preview</h4>
                            <v-spacer></v-spacer>
                            <v-menu>
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on">
                                  {{ previewStatus }}
                                  <v-icon right>fal fa-chevron-down</v-icon>
                                </v-btn>
                              </template>
                              <v-list dense>
                                <v-list-item v-for="(status, index) in statusOptions" :key="'status-' + index" @click="previewStatus = status">
                                  <v-list-item-title>{{ status }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-toolbar>
                          <v-card-title>{{ title }}</v-card-title>
                          <v-card-text>{{ subtitle }}</v-card-text>
                          <v-card-text v-if="previewStatus === 'Not Ready'">{{ extraText.notReady || 'All previous items must be ' + (activatable ? 'responded to' : 'viewed') + ' before this one' }}</v-card-text>
                          <v-card-text v-else-if="previewStatus === 'Not Viewed'">{{ extraText.notViewed || 'You have not yet viewed this item' }}</v-card-text>
                          <v-card-text v-else-if="previewStatus === 'Response: Yes'">{{ extraText.activated || 'You responded to this item in the affirmative' }}</v-card-text>
                          <v-card-text v-else-if="previewStatus === 'Response: No'">{{ extraText.deactivated || 'You responded to this item in the negative' }}</v-card-text>
                          <v-card-text v-else-if="previewStatus === 'Viewed'">{{ extraText.viewed || 'You have not yet viewed this item' }}</v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </v-col>
                </v-row>
                <v-checkbox v-model="popup" label="Make this item a popup (user can click on the timeline card to view more detail)"></v-checkbox>
                <template v-if="popup">
                  <h4 style="margin-top:1em">Additional Text</h4>
                  <p style="margin-bottom:.1em">These are additional lines of text that will appear based on the state of the item.</p>
                  <v-row>
                    <v-col v-if="inOrder">
                      <v-text-field v-model="extraText.notReady" :label="activatable ? 'Previous item has not been responded to' : 'Previous item has not been viewed'" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field v-model="extraText.notViewed" label="Item has not yet been viewed" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field v-model="extraText.viewed" label="Item has been viewed" outlined hide-details></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="activatable">
                    <v-col>
                      <v-text-field v-model="extraText.activated" label="'Yes' option selected" outlined hide-details></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field v-model="extraText.deactivated" label="'No' option selected" outlined hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="popup">
            <v-card>
              <v-card-text>
                <html-editor v-model="text" style="min-height:425px"></html-editor>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="popup">
            <v-card style="min-height:425px">
              <v-card-text>
                <p>The following are links that will appear at the bottom of the card. Leave blank to not show the link.</p>
                <v-row>
                  <v-col v-if="activatable">
                    <v-text-field v-model="actions.label" label="Label for 'Yes'/'No' radio" outlined></v-text-field>
                    <v-text-field v-model="actions.activate" label="'Yes' Response Text" outlined></v-text-field>
                    <v-text-field v-model="actions.deactivate" label="'No' Response Text" outlined></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="actions.contact" label="Contact Email" hint='Leave blank for none; will show as "Contact Us"' persistent-hint outlined></v-text-field>
                    <v-text-field v-model="actions.link" label="More Info Link" hint='Leave blank for none; will show as "More Info"' persistent-hint outlined></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="error" @click="removeItem(index)">Remove Popup Item</v-btn>
      </v-card-actions>
    </v-card>
  </v-tab-item>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
export default {
  props: {
    activatable: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    inOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HtmlEditor: () => import('@/components/forms/HTMLEditor')
  },
  setup (props, { emit }) {
    const activeTab = ref(0)

    const popup = ref('popup' in props.item ? props.item.popup : false)

    const title = ref(props.item.title || '')
    const subtitle = ref(props.item.subtitle || '')
    const text = ref(props.item.text || '')

    const extraText = ref(props.item.extraText || {
      notReady: 'Previous item has not been viewed',
      viewed: '',
      notViewed: 'Item has not been viewed',
      activated: 'Item has been responded to with a "Yes"',
      deactivated: 'Item has been responded to with a "No"'
    })
    const actions = ref(props.item.actions || {
      label: 'Response',
      activate: 'Activate',
      deactivate: 'Deactivate',
      link: '',
      contact: ''
    })

    watch(popup, () => !('popup' in props.item) || popup.value !== props.item.popup ? emit('update', { popup: popup.value }) : '')
    watch(title, () => title.value !== props.item.title ? emit('update', { title: title.value }) : '')
    watch(subtitle, () => subtitle.value !== props.item.subtitle ? emit('update', { subtitle: subtitle.value }) : '')
    watch(text, () => text.value !== props.item.text ? emit('update', { text: text.value }) : '')
    watch(extraText, () => JSON.stringify(extraText.value) !== JSON.stringify(props.item.extraText) ? emit('update', { extraText: extraText.value }) : '')
    watch(actions, () => JSON.stringify(actions.value) !== JSON.stringify(props.item.actions) ? emit('update', { actions: actions.value }) : '')

    watch(() => props.item, () => {
      if (props.item.popup !== popup.value) popup.value = props.item.popup
      if (props.item.title !== title.value) title.value = props.item.title
      if ('subtitle' in props.item && props.item.subtitle !== title.value) title.value = props.item.title
      if (props.item.text !== text.value) text.value = props.item.text
      if (JSON.stringify(extraText.value) !== JSON.stringify(props.item.extraText)) {
        for (let l in props.item.extraText) {
          extraText.value[l] = props.item.extraText[l]
        }
      }
      if (JSON.stringify(actions.value) !== JSON.stringify(props.item.actions)) {
        for (let l in props.item.actions) {
          actions.value[l] = props.item.actions[l]
        }
      }
    })

    const previewStatus = ref('Not Viewed')
    const statusOptions = computed(() => {
      let arr = []
      if (props.inOrder) arr.push('Not Ready')
      arr.push('Not Viewed')
      arr.push('Viewed')
      if (props.activatable) {
        arr.push('Response: Yes')
        arr.push('Response: No')
      }
      return arr
    })
    function getButtonColor () {
      if (props.activatable) {
        if (previewStatus.value === 'Response: Yes') return 'success'
        if (previewStatus.value === 'Response: No') return 'error'
      }
      return 'info'
    }

    function getButtonIcon () {
      if (previewStatus.value === 'Viewed') {
        if (props.activatable) return 'fas fa-question-circle'
        else return 'fas fa-check-circle'
      }
      if (props.activatable) {
        if (previewStatus.value === 'Response: No') return 'fas fa-times-circle'
        if (previewStatus.value === 'Response: Yes') return 'fas fa-check-circle'
      }
      return 'fas fa-exclamation-circle'
    }

    return {
      popup,
      title,
      subtitle,
      extraText,
      text,
      actions,
      activeTab,
      previewStatus,
      statusOptions,
      getButtonColor,
      getButtonIcon
    }
  }
}
</script>
